import { render } from "./customForm.vue?vue&type=template&id=95395502&scoped=true"
import script from "./customForm.vue?vue&type=script&lang=js"
export * from "./customForm.vue?vue&type=script&lang=js"

import "./customForm.vue?vue&type=style&index=0&id=95395502&scoped=true&lang=css"

import exportComponent from "A:\\Practice_Websites\\paint-amount\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95395502"]])

export default __exports__